import Image from 'next/image';
import Link from 'next/link'
import { useEffect, useState } from 'react';

import facebookSVG from "../public/images/facebook.svg";

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 0;
            setScrolled(isScrolled);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav class={`navbar px-5 px-sm-2 ${scrolled ? 'scrolled' : ''}`}>
            <Link class="navbar-brand" href="#">
                <img src="/images/logo.png" alt="Bootstrap"/> 
            </Link>
            <div class={`navbar-container ${isMenuOpen ? 'show' : 'hide'}`}>
                <Link href='/' className='nav-link'>
                    Home
                </Link>
                
                <Link href='/about' className='nav-link'>
                    About Us
                </Link>

                <div class="dropdown nav-dropdown">
                    <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Solutions
                    </button>
                    <ul class="dropdown-menu">
                        <li><Link class="dropdown-item" href="/solutions/lighting">Lighting</Link></li>
                        <li><Link class="dropdown-item" href="/solutions/sounds">Sounds</Link></li>
                         <li><Link class="dropdown-item" href="/solutions/video">Video</Link></li>
                        <li><Link class="dropdown-item" href="/solutions/system">System</Link></li>
                    </ul>
                </div>
{/* 
                <Link href='/projects' className='nav-link'>
                    Pro
                </Link> */}

                <Link href='/contact' className='nav-link'>
                    Contact Us
                </Link>
                <div className='social-icons'>
                <Link href={'https://www.facebook.com/profile.php?id=100009751877436'} className='nav-link'>
                    <span className='fab fa-facebook'></span>
                </Link>
                {/* <Link href={'https://www.twitter.com'} className='nav-link'>
                    <span className='fab fa-twitter'></span>
                </Link>
                <Link href={'https://www.instagram.com'} className='nav-link'>
                    <span className='fab fa-instagram'></span>
                </Link> */}

                <Link href={"tel:0286567856"} className='nav-link'>
                    <span className='fa fa-mobile'></span>
                </Link>
                </div>
            </div>
            
            <button class="navbar-toggler" type="button" onClick={toggleMenu}>
                <span class="navbar-toggler-icon"></span>
            </button>
        </nav>
    );
}